<div class="header-fixed" *ngIf="{ isAuthorized: isAuthorized$ | async } as model">
  <mat-toolbar class="test-class" *ngIf="model.isAuthorized">
    <mat-toolbar-row>
      <button mat-icon-button (click)="toggleSidebar()" *ngIf="isAuthorized">
        <mat-icon *ngIf="!toggled">menu</mat-icon>
        <mat-icon *ngIf="toggled">menu_open</mat-icon>
      </button>

      <a [href]="relihUrl" target="_blank"><img class="logo-image" src="/assets/logo/logo-en-transparent.png" /></a>
      <a [href]="habitatUrl" target="_blank"><img class="logo-image" src="/assets/logo/logo-en-transparent1.png" />
      </a>

      <div fxFlex fxLayout="row" fxLayoutAlign="flex-end">
        <ul fxLayout="row" fxLayoutGap="20px">
          <li>
            <button mat-button [matMenuTriggerFor]="menu2">
              <mat-icon>person_outline</mat-icon>
              <span class="hide-on-small-screen">{{ accountInfo.email }}</span>
            </button>
            <mat-menu #menu2="matMenu">
              <button mat-menu-item (click)="openChangePassword()">
                <mat-icon>vpn_key</mat-icon>
                {{ "change-password" | translate }}
              </button>
              <button mat-menu-item (click)="logout()">
                <mat-icon>exit_to_app</mat-icon>
                {{ "sign-out" | translate }}
              </button>
            </mat-menu>
          </li>
          <li>
            <div class="language-list">
              <button (click)="switchLang(item)" mat-button *ngFor="let item of getLanguages()">
                <span [ngClass]="getFlagClass(item)"></span>
                <span [ngClass]="item === language ? 'bold underlined' : ''">{{
                  item | uppercase
                  }}</span>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</div>
